import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetPlayerSessionInfo = () => {
    const send = useGenericSend();

    return useCallback(async (options?: { signal?: AbortSignal }): Promise<Types.IGetPlayerSessionInfoResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetPlayerSessionInfoResponseData>({
            ID: 35763,
            responses: [35764, 35765],
            description: 'Get Player Session Info'
        }, options);

        return data;
    }, [
        send
    ]);
};
